export default {
  "app.name": "لاوندري بوكس",
  "app.tagline": "غسيلك.. بدون انتظار",
  "app.dashboard": "لوحة تحكم المغسلة",

  "lang.ar": "العربية",
  "lang.en": "English",
  "lang.switch": "تغيير اللغة",

  "common.loading": "جارٍ التحميل…",
  "common.retry": "إعادة المحاولة",
  "common.cancel": "إلغاء",
  "common.close": "إغلاق",
  "common.save": "حفظ",
  "common.confirm": "تأكيد",
  "common.optional": "اختياري",
  "common.currency": "ر.س",
  "common.viewDetails": "عرض التفاصيل",
  "common.backToHome": "العودة إلى الرئيسية",
  "common.required": "هذا الحقل مطلوب",
  "common.invalidEmail": "البريد الإلكتروني غير صحيح",
  "common.demoData": "معاينة ببيانات تجريبية",
  "common.demoNote": "هذه معاينة ببيانات تجريبية.",
  "common.errorTitle": "تعذّر تحميل البيانات",
  "common.errorText": "حدث خطأ أثناء جلب البيانات. حاول مرة أخرى.",
  "common.empty": "لا توجد بيانات للعرض",
  "common.requiredMark": "مطلوب",
  "common.saving": "جارٍ الحفظ…",
  "common.processing": "جارٍ المعالجة…",

  "common.imageViewer.hint": "انقر على الصورة لتكبيرها",
  "common.imageViewer.zoomedHint": "اسحب للتنقل، وانقر للعودة للحجم الطبيعي",
  "common.imageViewer.zoomIn": "تكبير",
  "common.imageViewer.zoomOut": "تصغير",
  "common.imageViewer.reset": "الحجم الطبيعي",
  "upload.tooLarge": "حجم الملف أكبر من الحد المسموح ({size} م.ب).",
  "upload.wrongType": "صيغة الملف غير مدعومة.",

  "location.pick": "تحديد موقع المغسلة على الخريطة",
  "location.hint": "انقر على الخريطة لتحديد نقطة موقع المغسلة بدقة.",
  "location.demoBadge": "اختيار تجريبي — معاينة ببيانات تجريبية",
  "location.empty": "لم يتم تحديد الموقع بعد",
  "location.selectedAt": "النقطة المحددة (تجريبي)",
  "location.notSelected": "لم يتم التحديد",
  "location.clear": "إعادة التحديد",
  "location.addressLabel": "العنوان المُدخل",

  "navGroup.main": "رئيسي",
  "navGroup.management": "الإدارة",

  "nav.home": "الرئيسية",
  "nav.orders": "الطلبات",
  "nav.items": "القطع والخدمات",
  "nav.drivers": "المندوبون التابعون",
  "nav.finance": "المالية والتسويات",
  "nav.reviews": "التقييمات",
  "nav.notifications": "الإشعارات",
  "nav.settings": "الإعدادات",

  "topbar.notifications": "الإشعارات",
  "topbar.account": "الحساب",
  "topbar.logout": "تسجيل الخروج",
  "topbar.menu": "القائمة",
  "topbar.collapseSidebar": "تصغير القائمة الجانبية",
  "topbar.expandSidebar": "توسيع القائمة الجانبية",

  "status.new": "بانتظار قبول المغسلة",
  "status.accepted": "مقبول",
  "status.under_review": "تم الاستلام — جاري مراجعة الطلب",
  "status.in_progress": "قيد التنفيذ",
  "status.ready_for_delivery": "جاهز للتسليم",
  "status.completed": "مكتمل",
  "status.cancelled": "ملغى",

  "priority.normal": "عادي",
  "priority.urgent": "مستعجل",

  "fulfillment.self_dropoff_driver_delivery": "استلام من الفرع، توصيل من المندوب",
  "fulfillment.self_dropoff_self_pickup": "استلام وتسليم من الفرع",
  "fulfillment.driver_pickup_self_pickup": "استلام من المندوب، تسليم من الفرع",
  "fulfillment.driver_pickup_driver_delivery": "استلام وتوصيل من الموقع",

  "stub.title": "هذا القسم قيد الإنشاء",
  "stub.text": "سيتم تنفيذ محتوى هذا القسم في المرحلة التالية من لوحة تحكم المغسلة.",
  "stub.orderDetail": "ستُستكمل تفاصيل الطلب في مرحلة إدارة الطلبات.",

  "notFound.title": "الصفحة غير موجودة",
  "notFound.text": "تعذّر العثور على الصفحة المطلوبة، أو أنها قيد الإنشاء.",
  "notFound.action": "العودة إلى الرئيسية"
};